export enum ProductFileType {
    Banner = 'banner_image',
    Description = 'description_image',
    Attachment = 'attachement_file',
}
